import React from 'react';
import { Box, Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

export default function OrderDetailsDataTable({ details, total }) {
    return (
        <TableContainer component={Card} sx={{ elevation: 0, border: '1px solid #e0e0e0', borderRadius: 3, boxShadow: 'none' }}>
            <Table sx={{ minWidth: 700 }}>
                <TableHead sx={{ bgcolor: '#f8f9fa' }}>
                    <TableRow>
                        <TableCell width={'40%'}><Typography variant="caption" fontWeight="bold" color="text.secondary" textTransform="uppercase">Artículo</Typography></TableCell>
                        <TableCell align='center'><Typography variant="caption" fontWeight="bold" color="text.secondary" textTransform="uppercase">Cantidad</Typography></TableCell>
                        <TableCell align='right'><Typography variant="caption" fontWeight="bold" color="text.secondary" textTransform="uppercase">Precio Unit.</Typography></TableCell>
                        <TableCell align='right'><Typography variant="caption" fontWeight="bold" color="text.secondary" textTransform="uppercase">Subtotal</Typography></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {details.map((item, index) => (
                        <TableRow key={index} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell>
                                <Box>
                                    <Typography variant='body2' fontWeight="bold" color="#333">{item.product_name}</Typography>
                                    <Typography variant='caption' color="text.secondary">{item.description}</Typography>
                                </Box>
                            </TableCell>
                            <TableCell align='center'>
                                <Typography variant='body2' fontWeight="500">{parseFloat(item.quantity).toFixed(2)}</Typography>
                            </TableCell>
                            <TableCell align='right'>
                                <Typography variant='body2' color="text.secondary">${parseFloat(item.price).toFixed(2)}</Typography>
                            </TableCell>
                            <TableCell align='right'>
                                <Typography variant='body2' fontWeight="bold" color="#222">${item.total_amount}</Typography>
                            </TableCell>
                        </TableRow>
                    ))}
                    {/* Fila de Total */}
                    <TableRow sx={{ bgcolor: '#fafafa' }}>
                        <TableCell colSpan={3} align='right'>
                            <Typography fontWeight={700} variant='body1' color="#222">TOTAL DEL PEDIDO</Typography>
                        </TableCell>
                        <TableCell align='right'>
                            <Typography fontWeight={800} variant='h6' color="primary.main">${parseFloat(total).toFixed(2)}</Typography>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
}